import { ReactNode } from "react";
import { Box } from "@mui/material";
import "../components-styles.scss";
import "./Dossier/dossier-styles.scss";
import DossiersLayoutHeader from "./DossiersLayoutHeader";
import { TabMenu } from "@/src/types";
import { getLayoutHeaderTitleByUserRole } from "./utils";

type DossiersLayoutProps = {
    children: ReactNode;
    numberOfDossier: number;
    setFilterActiveTab: Function;
    filterTabsMenu: TabMenu[];
    setSearchQuery: Function;
    filterActiveTab: string;
    userRoleId: number;
    openBulkAssignedDossierModal?: Function;
    establishmentGroupsOptionsOfDossiers: any[];
    onEstablishmentGroupSelected: Function;
    establishementGroupSelected: number | null;
};

export default function DossiersLayout({
    children,
    numberOfDossier,
    setFilterActiveTab,
    setSearchQuery,
    filterTabsMenu,
    filterActiveTab,
    userRoleId,
    openBulkAssignedDossierModal,
    establishmentGroupsOptionsOfDossiers,
    onEstablishmentGroupSelected,
    establishementGroupSelected,
}: DossiersLayoutProps) {
    return (
        <>
            <header className="dossier-header">
                <DossiersLayoutHeader
                    headerTitle={getLayoutHeaderTitleByUserRole(userRoleId)}
                    numberOfDossier={numberOfDossier}
                    setFilterActiveTab={setFilterActiveTab}
                    filterTabsMenu={filterTabsMenu}
                    setSearchQuery={setSearchQuery}
                    filterActiveTab={filterActiveTab}
                    userRoleId={userRoleId}
                    openBulkAssignedDossierModal={openBulkAssignedDossierModal}
                    establishmentGroupsOptionsOfDossiers={
                        establishmentGroupsOptionsOfDossiers
                    }
                    onEstablishmentGroupSelected={onEstablishmentGroupSelected}
                    establishementGroupSelected={establishementGroupSelected}
                />
            </header>
            <main className="layout-body" style={{ overflow: "hidden" }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "3rem",
                        marginLeft: "6rem",
                        marginRight: "6rem",
                        marginTop: "2rem",
                        width: "100%",
                        "@media (max-width:1024px)": {
                            marginRight: "1.5rem",
                            marginLeft: "1.5rem",
                            width: "100vh",
                            marginBottom: "4.5rem",
                        },
                        "@media (min-width: 600px) and (max-width:1024px)": {
                            width: "100vw",
                        },
                    }}
                >
                    {children}
                </Box>
            </main>
        </>
    );
}
